import { useState } from "react";

import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";

import {
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import TextField from "src/components/core/TextField";
import CloseIcon from "@mui/icons-material/Close";

const AddStyleDialog = ({ initialValue, onClose, onSubmit }) => {
  const [value, setValue] = useState(initialValue);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: 429,
            maxWidth: "100%",
          },
        },
        "& .MuiDialogContent-root": {
          pt: 1,
          pb: 4,
        },
      }}
    >
      <DialogTitle sx={{ p: 3, textAlign: "center" }}>
        Add new style
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          variant="outlined"
          fullWidth
          value={value}
          onChange={(e) => setValue(e.target.value)}
          // autoFocus
        />
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
        }}
      >
        <Button
          variant="outlined"
          size="large"
          onClick={onClose}
          sx={{
            minWidth: 160,
          }}
        >
          ยกเลิก
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={() => onSubmit(value)}
          sx={{
            minWidth: 160,
          }}
          autoFocus // enable auto focus to increase accessibility
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddStyleDialog;
